import { render } from "./search.vue?vue&type=template&id=57b7d8be"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"
script.render = render

export default script